import styled from 'styled-components';
import arrowDown from '../../img/arrow-down.png';

const FormField = styled.div`
	padding: 1px 0px 0px 0px;
	margin-bottom: 0px !important;
	position: relative;

	.icon {
		color: ${({ theme }) => theme.colorSubscriber};
	}

	.btn-cvv {
		font-size: 3px !important;
		background: ${({ theme }) => theme.backgroundBtnCVVSubscriber} !important;
		color: white;
		border: 0;
		margin-left: 10px;
		padding: 1px 2px;
		border-radius: 50%;
		margin-bottom: 3px;
	}

	.btn-cvv + .tooltip > .tooltip-inner {
		background-color: black !important;
		opacity: 1;
		font-weight: 600;
		color: white;
	}

	.form-terms input[type='checkbox'] {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		width: 20px;
		height: 20px;
		position: absolute;
		top: 12px;
		left: 0px;
		margin-right: 14px;
	}
	.form-terms input[type='checkbox']:focus {
		outline: 0;
	}
	.form-terms input[type='checkbox']:checked {
		background: #ffeb00;
		border: 3px solid #fff;
	}

	.form-terms label {
		margin-top: 10px;
		line-height: 1;
		opacity: 1;
		padding-left: 30px;
		position: relative;
		width: 100%;
		color: ${({ theme }) => theme.colorFormTermsSubscriber};
		font-family: ${({ theme }) => theme.fontFamilySubscriber};
		font-weight: ${({ theme }) => theme.fontWeightLabelSubscriber};
	}

	label {
		position: absolute;
		top: 0;
		margin-left: 10px;
		padding-top: 0;
		transition: all 200ms;
		opacity: 0.8;
		display: inline-block;
		z-index: 10;
		color: ${({ theme }) => theme.colorSubscriber};
		font-family: ${({ theme }) => theme.fontFamilySubscriber};
		font-weight: ${({ theme }) => theme.fontWeightLabelSubscriber};
		font-size: 14px;
	}

	label.subscriber {
		padding-top: 15px;
	}

	a {
		color: ${({ theme }) => theme.colorAnchorSubscriber};
		font-family: ${({ theme }) => theme.fontFamilySubscriber};
		font-weight: ${({ theme }) => theme.fontWeightLabelSubscriber};
	}

	.form-control {
		border: 1px solid hsl(0, 0%, 85%);
		border-radius: 10px;
		box-shadow: none;
		height: 45px;
		padding: 20;
		padding-top: 8px;
		line-height: 40px;
		background-color: #f4f4f4;
		color: ${({ theme }) => theme.colorSubscriber};
		font-family: ${({ theme }) => theme.fontFamilySubscriber};
		font-weight: ${({ theme }) => theme.fontWeightSubscriber};
		font-size: 15px;
	}

	.form-control:focus {
		border-color: ${({ theme }) => theme.colorBorderSubscriber};
	}
	.form-control:focus + label,
	.form-control:valid + label {
		font-size: 85%;
		transform: translate3d(-8.7px, -100%, 0);
		opacity: 1;
	}

	.form-control2:focus + label,
	.form-control2:valid + label {
		font-size: 85%;
		transform: translate3d(-8.7px, -100%, 0);
		opacity: 1;
	}

	.select-new select {
		padding: 13px 0 0 0 !important;
		border: 0 !important;
		border-bottom: 1px ${({ theme }) => theme.colorSubscriber} !important;
	}

	select.form-control {
		border: 1px solid hsl(0, 0%, 75%) !important;
		padding: 0 0px;
		z-index: 1;
		background: #f4f4f4;
		position: relative;
		appearance: none;
		-webkit-appearance: none;
		padding-top: 0px !important;
		padding-left: 10px !important;
	}

	.form-container {
	width: 270px;
	label {
		text-align: left !important;
		color: unset;
		margin-left: 0%;
	}
}

	.form-select:before {
		content: '';
		z-index: 0;
		width: 35px;
		height: 25%;
		display: block;
		position: absolute;
		filter: ${({ theme }) => theme.colorFilterIconSubscriber};
	}

	.form-select:after {
		content: '';
		z-index: 3;
		width: 35px;
		height: 25%;
		background: url(${arrowDown}) no-repeat center;
		display: block;
		position: absolute;
		top: 1.2em;
		right: 0;
		filter: ${({ theme }) => theme.colorFilterIconSubscriber};
	}

	select.form-control:focus {
		padding: 0 10px;
		z-index: 1;
		background: transparent;
		position: relative;
		appearance: none;
		-webkit-appearance: none;
		border-color: ${({ theme }) => theme.colorBorderSubscriber} !important;
	}

	/* The switch - the box around the slider */
	.switch {
		position: relative;
		display: inline-block;
		width: 60px;
		height: 34px;
	}

	/* Hide default HTML checkbox */
	.switch input {
		opacity: 0;
		width: 0;
		height: 0;
	}

	/* The slider */
	.slider {
		position: absolute;
		cursor: pointer;
		top: 0px;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: ${({ theme }) => theme.backgroundSliderSubscriber};
		transition: 0.4s;
		height: 16px !important;
		width: 26px;
	}

	.slider:before {
		position: absolute;
		content: '';
		height: 19px;
		width: 19px;
		left: -8px;
		bottom: -2px;
		background-color: white;
		transition: 0.4s;
		border: 1px solid #e4e4e4;
	}

	input:checked + .slider {
		background-color: ${({ theme }) => theme.backgroundSliderCheckedSubscriber};
	}

	input:focus + .slider {
		box-shadow: 0 0 1px #4cae46;
	}

	input:checked + .slider:before {
		-webkit-transform: translateX(19px);
		-ms-transform: translateX(19px);
		transform: translateX(19px);
	}

	/* Rounded sliders */
	.slider.round {
		border-radius: 34px;
		margin-right: 20px;
	}

	.slider.round:before {
		border-radius: 50%;
	}

	.error-msg {
		margin-left: 0px;
		display: flex;
		flex-direction: row;
		align-items: center;
		svg {
			color: ${({ theme }) => theme.colorErrorSubscriber};
		}
	}

	.credit-card-error {
		color: ${({ theme }) => theme.colorErrorSubscriber};
		font-family: ${({ theme }) => theme.fontFamilySubscriber};
		font-weight: ${({ theme }) => theme.fontWeightSubscriber};
		padding-left: 4px;
	}

	@media (max-width: 992px) {
		.slider {
			top: 0px;
		}

		.imageTooltip {
			max-width: 320px;
		}
	}

	.button-add-file {
		margin: auto;
		position: relative;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		background: transparent;
		color: ${({ theme }) => theme.colorBtnAddVoucherkFormButton};
		font-size: 16px;
		padding: 10px 5px;
		width: 350px;
		border: 1px solid ${({ theme }) => theme.borderBtnAddSubscriberFormButton};
		border-radius: 25px;
		cursor: pointer;

		svg {
			float: left;
			margin-left: 5px;
			color: ${({ theme }) => theme.colorBtnAddVoucherkFormButton};
		}

		strong {
			clear: both;
			margin: auto;
			font-weight: ${({ theme }) => theme.fontWeightFormButton};
			font-family: ${({ theme }) => theme.fontFamilyFormButton};
			text-align: center;
		}
	}

	.form-group2 .form-control2 {
    border: 0;
    border-bottom: 1px solid #666;
    border-radius: 0;
    box-shadow: none;
    line-height: 40px;
    color: #666;
    font-size: 16px;
		height: 40px;
    padding: 10px 0 0;
    margin-top: 5px;
}

.form-control2 {
    display: block;
    width: 100%;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    -webkit-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
		font-weight: unset;
}

.form-group2 .form-control2:focus {
	border-color: ${({ theme }) => theme.colorBorderBtn};
	outline: 0;
}

.form-group2 {
	margin-bottom: 5px !important;
}

.form-control2:focus + label,
.form-control2:valid + label {
	font-size: 75%;
	transform: translate3d(0, -40%, 0);
	opacity: 1;
}

.form-group2 label {
	position: absolute;
	top: 0;
	padding: 15px 0px 0px;
	transition: all 200ms;
	opacity: 0.8;
	display: inline-block;
}

.form-group3 label {

	top: 58px;

}

.form-number-phone {
	width: 270px;
	label {
		text-align: left !important;
		color: unset;
		margin-left: 0%;
	}
	}

`;

export default FormField;
